export enum ExerciseTypeEnum {
  Exercise = 'exercise',
  Stretch = 'stretch',
  Question = 'question'
}
